// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__HF_XG","label":"Completed_label__2OqeD"};